// 存放Local Storage键值
export const ACCESS_TOKEN = 'Access-Token'
export const ACCESS_SUNID = 'Access-SubjectId'
export const LANGUAGE = 'language'
